import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private domain = environment.domain;
  constructor(private http: HttpClient) { }

  //departments
  getListDepartments() {
    return this.http.get(this.domain + `hierarchy/departments`);
  }
  
  getListUsers() {
    return this.http.get(this.domain + `auth/users`);
  }
  getDepartmentById(departmentId: number) {
    return this.http.get(this.domain + `hierarchy/departments/${departmentId}`);
  }
  createDepartments(model: any) {
    return this.http.post(this.domain + `hierarchy/departments`, model);
  }
  updateDepartments(departmentId: number, model: any) {
    return this.http.put(this.domain + `hierarchy/departments/${departmentId}`, model);
  }
  deleteDepartments(departmentId: number) {
    return this.http.delete(this.domain + `hierarchy/departments/${departmentId}`);
  }



  //section
  getListSections() {
    return this.http.get(this.domain + `sections`);
  }
  getSectionById(sectionId: number) {
    return this.http.get(this.domain + `sections/${sectionId}`);
  }
  createSection(model: any, departmentId: number) {
    return this.http.post(this.domain + `hierarchy/departments/${departmentId}/sections`, model);
  }
  updateSection(sectionId: number, departmentId: number, model: any) {
    return this.http.put(this.domain + `hierarchy/departments/${departmentId}/sections/${sectionId}`, model);
  }
  deleteSection(sectionId: number, departmentId: number) {
    return this.http.delete(this.domain + `hierarchy/departments/${departmentId}/sections/${sectionId}`);
  }
  getOrgChart() {
    return this.http.get(this.domain + `hierarchy`);
  }


  //reports
  viewUsersReport(type: string) {
    return this.http.get(this.domain + `strategies/1/reports/users?mode=view&type=${type}`);
  }
  DownloadUsersReport(type: string) {
    return this.http.get(this.domain + `strategies/1/reports/users?mode=download&type=${type}`, {
      responseType: 'blob'
    });
  }




  //department management 
  getDepartmentDeletionPreview(departmentId: number) {
    return this.http.get(this.domain + `hierarchy/departments/${departmentId}/deletion-preview`);
  }
  getSectiontDeletionPreview(sectionId: number) {
    return this.http.get(this.domain + `hierarchy/sections/${sectionId}/deletion-preview`);
  }
  transferDepartmentProjects(departmentId: number, payload: any) {
    return this.http.put(this.domain + `hierarchy/departments/${departmentId}/projects/transfer`, payload);
  }
  transferSectionProjects(sectionId: number, payload: any) {
    return this.http.put(this.domain + `hierarchy/sections/${sectionId}/projects/transfer`, payload);
  }
  transferDepartmentEmployees(departmentId: number, payload: any) {
    return this.http.put(this.domain + `hierarchy/departments/${departmentId}/employees/transfer`, payload);
  }
  transferSectionEmployees(departmentId: number, payload: any) {
    return this.http.put(this.domain + `hierarchy/sections/${departmentId}/employees/transfer`, payload);
  }

  getUserDeletionPreview(userId: number) {
    return this.http.get(this.domain + `users/${userId}/deletion-preview`);
  }
  transferIndicators(userId: number, model: any) {
    return this.http.put(this.domain + `users/${userId}/indicators/transfer`, model);
  }
  TransferUserProjects(userId: number, model: any) {
    return this.http.put(this.domain + `users/${userId}/projects/transfer`, model);
  }

}












